
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.167.625a.543.543 0 00-.542.542 9.208 9.208 0 009.208 9.208.543.543 0 00.542-.542V7.937a.543.543 0 00-.542-.541A6.153 6.153 0 017.9 7.087a.553.553 0 00-.553.13L6.155 8.41a8.15 8.15 0 01-3.57-3.57l1.192-1.197a.52.52 0 00.136-.542 6.153 6.153 0 01-.309-1.933.543.543 0 00-.542-.542H1.167zm5.958 0v.813h1.896L6.04 4.417l.542.541 2.98-2.979v1.896h.812V.625h-3.25z","fill":"#263238"}})])
          )
        }
      }
    